<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitlea"><a id="page_ix"></a>Contents</p>
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="15%"/>
<col width="85%"/>
</colgroup><tbody><tr>
<td valign="top"><p class="toc"><a href="#/06_chapter01#chapter01" id="rchapter01">Chapter 1:</a></p></td>
<td valign="top"><p class="toc1"><a href="#/06_chapter01#chapter01">‘I have to be seen to be believed’</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><a href="#/07_chapter02#chapter02" id="rchapter02">Chapter 2:</a></p></td>
<td valign="top"><p class="toc1"><a href="#/07_chapter02#chapter02">‘It is a great inheritance – and a heavy burden – on the girl who becomes Queen’</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><a href="#/08_chapter03#chapter03" id="rchapter03">Chapter 3:</a></p></td>
<td valign="top"><p class="toc1"><a href="#/08_chapter03#chapter03">‘Do you come here often?’</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/09_chapter04#chapter04" id="rchapter04" title="Link target outside of Sample">Chapter 4:</span></p></td>
<td valign="top"><p class="toc1"><span href="#/09_chapter04#chapter04" title="Link target outside of Sample">‘Our great problem is democracy’</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/10_chapter05#chapter05" id="rchapter05" title="Link target outside of Sample">Chapter 5:</span></p></td>
<td valign="top"><p class="toc1"><span href="#/10_chapter05#chapter05" title="Link target outside of Sample">‘An entire effacement of self’</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/11_chapter06#chapter06" id="rchapter06" title="Link target outside of Sample">Chapter 6:</span></p></td>
<td valign="top"><p class="toc1"><span href="#/11_chapter06#chapter06" title="Link target outside of Sample">‘A sphere beyond politics’</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/12_chapter07#chapter07" id="rchapter07" title="Link target outside of Sample">Chapter 7:</span></p></td>
<td valign="top"><p class="toc1"><span href="#/12_chapter07#chapter07" title="Link target outside of Sample">‘You have mosquitoes, I have the press’</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/13_chapter08#chapter08" id="rchapter08" title="Link target outside of Sample">Chapter 8:</span></p></td>
<td valign="top"><p class="toc1"><span href="#/13_chapter08#chapter08" title="Link target outside of Sample">‘I think we’re a soap opera’</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/14_chapter09#chapter09" id="rchapter09" title="Link target outside of Sample">Chapter 9:</span></p></td>
<td valign="top"><p class="toc1"><span href="#/14_chapter09#chapter09" title="Link target outside of Sample">‘Speak to us, Ma’am’</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/15_chapter10#chapter10" id="rchapter10" title="Link target outside of Sample">Chapter 10:</span></p></td>
<td valign="top"><p class="toc1"><span href="#/15_chapter10#chapter10" title="Link target outside of Sample">‘What does she do with it?’</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/16_chapter11#chapter11" id="rchapter11" title="Link target outside of Sample">Chapter 11:</span></p></td>
<td valign="top"><p class="toc1"><span href="#/16_chapter11#chapter11" title="Link target outside of Sample">‘A spirit of loyal enthusiasm’</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/17_chapter12#chapter12" id="rchapter12" title="Link target outside of Sample">Chapter 12:</span></p></td>
<td valign="top"><p class="toc1"><span href="#/17_chapter12#chapter12" title="Link target outside of Sample">‘Safer not to be too popular. You can’t fall too far’</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toct"><span href="#/18_backmatter01#notes" id="rnotes" title="Link target outside of Sample">Source Notes</span></p></td>
<td valign="top"><p class="toc1t"> </p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/19_backmatter02#bib" id="rbib" title="Link target outside of Sample">Bibliography</span></p></td>
<td valign="top"><p class="toc1"> </p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/20_backmatter03#acknowledgements" id="racknowledgements" title="Link target outside of Sample">Acknowledgements</span></p></td>
<td valign="top"><p class="toc1"> </p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/21_index#index" id="rindex" title="Link target outside of Sample">Index</span></p></td>
<td valign="top"><p class="toc1"> <a id="page_x"></a></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?e690b8c8